import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { AzureAssetPipe } from './pipes/azure-asset.pipe';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { Injector, NgModule } from '@angular/core';
import { createCustomElement } from '@angular/elements';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { AlphabetFilterComponent } from './alphabet-filter/alphabet-filter.component';
import { NgSelectModule } from '@ng-select/ng-select';

import { ExhibitorEntryComponent } from './exhibitor-entry/exhibitor-entry.component';
import { ExhibitorsDirectoryComponent } from './exhibitors-directory.component';
import { ExhibitorsFiltersPipe } from './filters/exhibitors-filters-pipe';
import { LoaderComponent } from './loader/loader.component';
import { ExtendedExhibitorEntryComponent } from './exhibitor-entry/extended-exhibitor-entry/extended-exhibitor-entry.component';
import { TruncatePipe } from './pipes/truncate.pipe';
import { StoragePrefixPipe } from './pipes/storage-prefix.pipe';
import { PresentationsComponent } from './presentations/presentations.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { VideoPopupComponent } from './video-popup/video-popup.component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { map, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

class ExhibitorsDirectoryTranslationLoader implements TranslateLoader {
  constructor(private _http: HttpClient) {}

  getTranslation(lang: string): Observable<any> {
    let translationFileUrl = `${environment.blobStorageUrl}/cdn/exhibitors-directory/i18n/translations.json`;

    return this._http.get(translationFileUrl).pipe(map((translations: any) => translations[lang] || translations['en']));
  }
}

@NgModule({
    declarations: [
        ExhibitorsDirectoryComponent,
        ExhibitorEntryComponent,
        LoaderComponent,
        AlphabetFilterComponent,
        ExhibitorsFiltersPipe,
        ExtendedExhibitorEntryComponent,
        TruncatePipe,
        AzureAssetPipe,
        StoragePrefixPipe,
        PresentationsComponent,
        VideoPopupComponent,
    ],
    imports: [
        BrowserModule,
        HttpClientModule,
        FormsModule,
        NgSelectModule,
        BrowserAnimationsModule,
        MatDialogModule,
        MatIconModule,
        TranslateModule.forRoot({
          loader: { provide: TranslateLoader, useClass: ExhibitorsDirectoryTranslationLoader, deps: [HttpClient] }
      })
    ],
    exports: [
        StoragePrefixPipe
    ]
})
export class ExhibitorsDirectoryModule {
  constructor(private injector: Injector) {}
  ngDoBootstrap() {
    const injector = { injector: this.injector };
    customElements.define('sbc-exhibitors-directory', createCustomElement(ExhibitorsDirectoryComponent, injector));
  }
}

